export const CREDIT_SCALE = 1_000_000; // 1 credit = 1,000,000 micro-credits
